import { useStaticQuery, graphql } from "gatsby"

// 取得文章資料，作為文章頁中的熱門文章區塊所使用
const usePopularPost = () => {
  const data = useStaticQuery(graphql`
    query MyQuery {
      allContentfulPost(filter: { isPopularInPost: { eq: true } }) {
        nodes {
          id
          slug
          name
          updatedAt(formatString: "YYYY-MM-DD")
          topic {
            slug
            name
          }
          excerpt {
            excerpt
          }
          image {
            gatsbyImageData(width: 768, height: 512, placeholder: BLURRED)
          }
        }
      }
    }
  `)
  const {
    allContentfulPost: { nodes: popularPosts },
  } = data

  return popularPosts
}

export default usePopularPost
